
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"-225 -114 450 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M-225-114h450v300h-450z"}}),_c('g',{attrs:{"fill":"#CE1126"}},[_c('circle',{attrs:{"r":"64.5"}}),_c('path',{attrs:{"d":"M-225-14h450V86h-450z"}}),_c('g',{attrs:{"id":"e"}},[_c('g',{attrs:{"id":"d"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0-102c-2.2 0-3 3.3-3 6.5 0 8 1 12 3 23.5 2.04-11.5 3-15.6 3-23.5 0-3.3-1-6.5-3-6.5"}}),_c('use',{attrs:{"transform":"rotate(5)","xlink:href":"#a"}})]),_c('use',{attrs:{"transform":"rotate(10)","xlink:href":"#b"}})]),_c('use',{attrs:{"transform":"rotate(20)","xlink:href":"#c"}})]),_c('use',{attrs:{"transform":"rotate(40)","xlink:href":"#d"}})]),_c('use',{attrs:{"transform":"rotate(-80)","xlink:href":"#e"}})]),_c('path',{attrs:{"d":"M-225-21.5h450v7.5h-450z"}}),_c('path',{attrs:{"fill":"#339E35","d":"M-225 86h450v100h-450z"}})])
          )
        }
      }
    